var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0773 14.5881V8.7608C16.0773 8.35538 15.9936 7.95422 15.8312 7.58189C15.6687 7.20956 15.4311 6.8739 15.1327 6.59548L9.57446 1.40707C9.29452 1.14565 8.92389 1 8.53865 1C8.15341 1 7.78278 1.14565 7.50284 1.40707L1.94459 6.59548C1.64623 6.8739 1.40856 7.20956 1.24614 7.58189C1.08371 7.95422 0.999956 8.35538 1 8.7608V14.5881C1 14.9831 1.15885 15.3618 1.4416 15.6411C1.72436 15.9204 2.10786 16.0773 2.50773 16.0773H14.5696C14.9694 16.0773 15.3529 15.9204 15.6357 15.6411C15.9185 15.3618 16.0773 14.9831 16.0773 14.5881Z",
    stroke: "#003E52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.fd1c81df8e63e7b3cccd14e651be6f6a.svg";
export { ForwardRef as ReactComponent };